module.exports = __webpack_public_path__ + "img/babu.5b62f72d.png";